import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Which scene to draw: 0 Discover (trip replay), 1 Connect (crew + sharing), 2 Enhance (automation). */
export type LoginSceneIndex = 0 | 1 | 2;

/**
 * Login slider art for the `?slides=graphic` variant: a tilted nautical chart carrying the app's own
 * boat skins and waypoint pins, with floating UI cards that show what each slide's headline means.
 * CSS 3D + inline SVG only (no libraries); animations pause while the slide is not showing.
 */
@Component({
  selector: 'app-login-slide-art',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login-slide-art.component.html',
  styleUrl: './login-slide-art.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginSlideArtComponent {
  @Input({ required: true }) scene: LoginSceneIndex = 0;
  @Input() active = false;
}
